interface LoadingSkeletonProps {
  count?: number;
  cols?: string;
  height?: string;
}

export function LoadingSkeleton({
  count = 6,
  cols = 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4',
  height = 'h-28 sm:h-32',
}: LoadingSkeletonProps) {
  return (
    <div className={`grid ${cols} gap-2 sm:gap-4`}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`glass-card p-3 sm:p-5 rounded-2xl animate-pulse ${height}`}
        />
      ))}
    </div>
  );
}
